<template>
  <div class="line-height-lg">
    <!-- #777 양식 없애기: 텍스트박스와 동일한 외관, 본문만 출력 -->
    <div v-if="bare_mode" class="bc-bare-mode-viewer" @click="openImgPopup">
      <template v-if="effectiveLang != 'ENG'">
        <HtmlText :content="business_case_obj.description" />
      </template>
      <template v-else>
        <HtmlText :content="business_case_obj?.translated?.description_e" />
      </template>
    </div>

    <div v-else @click="openImgPopup">
      <div
        :class="[
          'border-radius border pt-0 px-3 py-3',
          { 'bgray-100': background_color === '#FFFFFF00' }
        ]"
        :style="background_color !== '#FFFFFF00' ? `background-color: ${background_color}` : ''"
      >
        <div
          v-if="business_case_obj?.badge_text != '' || show_title"
          class="d-flex align-items-center border-radius mb-3 flex-wrap"
        >
          <div
            v-if="business_case_obj?.badge_text != ''"
            class="fw-600 mr-3 business-case-badge"
            :style="`background-color: ${selected_report.main_color}`"
          >
            {{
              effectiveLang != 'ENG'
                ? business_case_obj?.badge_text
                : business_case_obj?.translated?.badge_text_e || business_case_obj?.badge_text
            }}
          </div>

          <h5 v-if="show_title" class="fw-600 gray-800 mb-0">
            {{
              effectiveLang != 'ENG'
                ? business_case_obj.title
                : business_case_obj?.translated?.title_e
            }}
          </h5>
        </div>

        <template v-if="effectiveLang != 'ENG'">
          <HtmlText :content="business_case_obj.description" />
          <div
            v-if="business_case_id != '' && business_case_obj.files.length > 0"
            class="f-95 gray-600"
          >
            첨부파일 :
            <span v-for="item in business_case_obj.files" :key="item.id" class="mr-3">
              <a :href="$store.state.static_host + item.file_path" target="_blank">{{
                item.file_name
              }}</a>
            </span>
          </div>
        </template>

        <template v-else>
          <HtmlText :content="business_case_obj?.translated?.description_e" />
          <div
            v-if="business_case_id != '' && business_case_obj?.translated?.files.length > 0"
            class="f-95 gray-600"
          >
            Attatched File :
            <span v-for="item in business_case_obj?.translated?.files" :key="item.id" class="mr-3">
              <a :href="$store.state.static_host + item.file_path" target="_blank">{{
                item.file_name
              }}</a>
            </span>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import HtmlText from './HtmlText.vue';

export default {
  name: 'BusinessCaseSb',
  components: {
    HtmlText
  },
  props: {
    business_case_id: { type: [String, Number], default: '' },
    background_color: { type: String, default: '#f8f8f8' },
    business_case_obj: { type: Object, default: () => ({}) },
    show_title: { type: Boolean, default: true },
    print_mode: { type: Boolean, default: false },
    // #777 비즈니스 케이스 양식 없애기 — true일 때 외양을 모두 제거하고 본문만 출력
    bare_mode: { type: Boolean, default: false },
    // ''(빈 문자열)이면 store lang을 따름. 'KOR'/'ENG' 지정 시 강제.
    force_lang: { type: String, default: '' }
  },
  computed: {
    ...mapState('report_list', ['lang']),
    ...mapGetters('report_list', ['selected_report']),
    effectiveLang() {
      return this.force_lang !== '' ? this.force_lang : this.lang;
    }
  },
  methods: {
    openImgPopup(e) {
      const img = e.target;
      if (img.tagName === 'IMG') {
        this.$EventBus.$emit('image-modal', img.getAttribute('src'), true);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  font-family: inherit;
  line-height: 1.6;
  font-size: 1rem;
  font-weight: 400;
  margin-bottom: 1rem;
  letter-spacing: -0.01px;
  color: #111111;
  text-align: justify;
}

@media print {
  .line-height-lg,
  .line-height-lg * {
    overflow: visible !important;
  }
}

/* #777 bare_mode: 텍스트박스 외관 */
.bc-bare-mode-viewer {
  border: none;
  background: transparent;
  padding: 0;
}

.business-case-badge {
  font-size: 0.875rem;
  color: white;
  min-height: 30px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  line-height: 0.9;
}
</style>
